import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {filterSingle_multiLevel_selector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingle_multiLevel_selector_template";
import {vnApp_sentinelbi} from "../../components/vnApp_sentinelbi";
import { load } from 'recaptcha-v3';

declare var ko: any;


const stripe = Stripe(vnApp_sentinelbi.STRIPE_KEY);

const appearance = {
    base: {
        color: '#32325d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
    },
    invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
    }
};


const elements = stripe.elements();
const card = elements.create('card');

export class signup_template extends vnTemplate {

    protected propertyName: infoButton_template;
    protected propertyShortName: infoButton_template;
    protected propertyDomain: infoButton_template;
    protected plan: filterSingle_multiLevel_selector_template;
    protected timezone: filterSingle_multiLevel_selector_template;

    readonly plans = [
        {"id": 1, "name": "basic"},
        {"id": 2, "name": "essential"},
        {"id": 3, "name": "advanced"},
        {"id": 4, "name": "pro"}
    ];

    readonly timezones = [
        {"id": "Africa/Abidjan", "name": "Africa/Abidjan"},
        {"id": "Africa/Accra", "name": "Africa/Accra"},
        {"id": "Africa/Addis_Ababa", "name": "Africa/Addis_Ababa"},
        {"id": "Africa/Algiers", "name": "Africa/Algiers"},
        {"id": "Africa/Asmara", "name": "Africa/Asmara"},
        {"id": "Africa/Bamako", "name": "Africa/Bamako"},
        {"id": "Africa/Bangui", "name": "Africa/Bangui"},
        {"id": "Africa/Banjul", "name": "Africa/Banjul"},
        {"id": "Africa/Bissau", "name": "Africa/Bissau"},
        {"id": "Africa/Blantyre", "name": "Africa/Blantyre"},
        {"id": "Africa/Brazzaville", "name": "Africa/Brazzaville"},
        {"id": "Africa/Bujumbura", "name": "Africa/Bujumbura"},
        {"id": "Africa/Cairo", "name": "Africa/Cairo"},
        {"id": "Africa/Casablanca", "name": "Africa/Casablanca"},
        {"id": "Africa/Ceuta", "name": "Africa/Ceuta"},
        {"id": "Africa/Conakry", "name": "Africa/Conakry"},
        {"id": "Africa/Dakar", "name": "Africa/Dakar"},
        {"id": "Africa/Dar_es_Salaam", "name": "Africa/Dar_es_Salaam"},
        {"id": "Africa/Djibouti", "name": "Africa/Djibouti"},
        {"id": "Africa/Douala", "name": "Africa/Douala"},
        {"id": "Africa/El_Aaiun", "name": "Africa/El_Aaiun"},
        {"id": "Africa/Freetown", "name": "Africa/Freetown"},
        {"id": "Africa/Gaborone", "name": "Africa/Gaborone"},
        {"id": "Africa/Harare", "name": "Africa/Harare"},
        {"id": "Africa/Johannesburg", "name": "Africa/Johannesburg"},
        {"id": "Africa/Juba", "name": "Africa/Juba"},
        {"id": "Africa/Kampala", "name": "Africa/Kampala"},
        {"id": "Africa/Khartoum", "name": "Africa/Khartoum"},
        {"id": "Africa/Kigali", "name": "Africa/Kigali"},
        {"id": "Africa/Kinshasa", "name": "Africa/Kinshasa"},
        {"id": "Africa/Lagos", "name": "Africa/Lagos"},
        {"id": "Africa/Libreville", "name": "Africa/Libreville"},
        {"id": "Africa/Lome", "name": "Africa/Lome"},
        {"id": "Africa/Luanda", "name": "Africa/Luanda"},
        {"id": "Africa/Lubumbashi", "name": "Africa/Lubumbashi"},
        {"id": "Africa/Lusaka", "name": "Africa/Lusaka"},
        {"id": "Africa/Malabo", "name": "Africa/Malabo"},
        {"id": "Africa/Maputo", "name": "Africa/Maputo"},
        {"id": "Africa/Maseru", "name": "Africa/Maseru"},
        {"id": "Africa/Mbabane", "name": "Africa/Mbabane"},
        {"id": "Africa/Mogadishu", "name": "Africa/Mogadishu"},
        {"id": "Africa/Monrovia", "name": "Africa/Monrovia"},
        {"id": "Africa/Nairobi", "name": "Africa/Nairobi"},
        {"id": "Africa/Ndjamena", "name": "Africa/Ndjamena"},
        {"id": "Africa/Niamey", "name": "Africa/Niamey"},
        {"id": "Africa/Nouakchott", "name": "Africa/Nouakchott"},
        {"id": "Africa/Ouagadougou", "name": "Africa/Ouagadougou"},
        {"id": "Africa/Porto-Novo", "name": "Africa/Porto-Novo"},
        {"id": "Africa/Sao_Tome", "name": "Africa/Sao_Tome"},
        {"id": "Africa/Tripoli", "name": "Africa/Tripoli"},
        {"id": "Africa/Tunis", "name": "Africa/Tunis"},
        {"id": "Africa/Windhoek", "name": "Africa/Windhoek"},
        {"id": "America/Adak", "name": "America/Adak"},
        {"id": "America/Anchorage", "name": "America/Anchorage"},
        {"id": "America/Anguilla", "name": "America/Anguilla"},
        {"id": "America/Antigua", "name": "America/Antigua"},
        {"id": "America/Araguaina", "name": "America/Araguaina"},
        {"id": "America/Argentina/Buenos_Aires", "name": "America/Argentina/Buenos_Aires"},
        {"id": "America/Argentina/Catamarca", "name": "America/Argentina/Catamarca"},
        {"id": "America/Argentina/Cordoba", "name": "America/Argentina/Cordoba"},
        {"id": "America/Argentina/Jujuy", "name": "America/Argentina/Jujuy"},
        {"id": "America/Argentina/La_Rioja", "name": "America/Argentina/La_Rioja"},
        {"id": "America/Argentina/Mendoza", "name": "America/Argentina/Mendoza"},
        {"id": "America/Argentina/Rio_Gallegos", "name": "America/Argentina/Rio_Gallegos"},
        {"id": "America/Argentina/Salta", "name": "America/Argentina/Salta"},
        {"id": "America/Argentina/San_Juan", "name": "America/Argentina/San_Juan"},
        {"id": "America/Argentina/San_Luis", "name": "America/Argentina/San_Luis"},
        {"id": "America/Argentina/Tucuman", "name": "America/Argentina/Tucuman"},
        {"id": "America/Argentina/Ushuaia", "name": "America/Argentina/Ushuaia"},
        {"id": "America/Aruba", "name": "America/Aruba"},
        {"id": "America/Asuncion", "name": "America/Asuncion"},
        {"id": "America/Atikokan", "name": "America/Atikokan"},
        {"id": "America/Bahia", "name": "America/Bahia"},
        {"id": "America/Bahia_Banderas", "name": "America/Bahia_Banderas"},
        {"id": "America/Barbados", "name": "America/Barbados"},
        {"id": "America/Belem", "name": "America/Belem"},
        {"id": "America/Belize", "name": "America/Belize"},
        {"id": "America/Blanc-Sablon", "name": "America/Blanc-Sablon"},
        {"id": "America/Boa_Vista", "name": "America/Boa_Vista"},
        {"id": "America/Bogota", "name": "America/Bogota"},
        {"id": "America/Boise", "name": "America/Boise"},
        {"id": "America/Cambridge_Bay", "name": "America/Cambridge_Bay"},
        {"id": "America/Campo_Grande", "name": "America/Campo_Grande"},
        {"id": "America/Cancun", "name": "America/Cancun"},
        {"id": "America/Caracas", "name": "America/Caracas"},
        {"id": "America/Cayenne", "name": "America/Cayenne"},
        {"id": "America/Cayman", "name": "America/Cayman"},
        {"id": "America/Chicago", "name": "America/Chicago"},
        {"id": "America/Chihuahua", "name": "America/Chihuahua"},
        {"id": "America/Ciudad_Juarez", "name": "America/Ciudad_Juarez"},
        {"id": "America/Costa_Rica", "name": "America/Costa_Rica"},
        {"id": "America/Creston", "name": "America/Creston"},
        {"id": "America/Cuiaba", "name": "America/Cuiaba"},
        {"id": "America/Curacao", "name": "America/Curacao"},
        {"id": "America/Danmarkshavn", "name": "America/Danmarkshavn"},
        {"id": "America/Dawson", "name": "America/Dawson"},
        {"id": "America/Dawson_Creek", "name": "America/Dawson_Creek"},
        {"id": "America/Denver", "name": "America/Denver"},
        {"id": "America/Detroit", "name": "America/Detroit"},
        {"id": "America/Dominica", "name": "America/Dominica"},
        {"id": "America/Edmonton", "name": "America/Edmonton"},
        {"id": "America/Eirunepe", "name": "America/Eirunepe"},
        {"id": "America/El_Salvador", "name": "America/El_Salvador"},
        {"id": "America/Fort_Nelson", "name": "America/Fort_Nelson"},
        {"id": "America/Fortaleza", "name": "America/Fortaleza"},
        {"id": "America/Glace_Bay", "name": "America/Glace_Bay"},
        {"id": "America/Goose_Bay", "name": "America/Goose_Bay"},
        {"id": "America/Grand_Turk", "name": "America/Grand_Turk"},
        {"id": "America/Grenada", "name": "America/Grenada"},
        {"id": "America/Guadeloupe", "name": "America/Guadeloupe"},
        {"id": "America/Guatemala", "name": "America/Guatemala"},
        {"id": "America/Guayaquil", "name": "America/Guayaquil"},
        {"id": "America/Guyana", "name": "America/Guyana"},
        {"id": "America/Halifax", "name": "America/Halifax"},
        {"id": "America/Havana", "name": "America/Havana"},
        {"id": "America/Hermosillo", "name": "America/Hermosillo"},
        {"id": "America/Indiana/Indianapolis", "name": "America/Indiana/Indianapolis"},
        {"id": "America/Indiana/Knox", "name": "America/Indiana/Knox"},
        {"id": "America/Indiana/Marengo", "name": "America/Indiana/Marengo"},
        {"id": "America/Indiana/Petersburg", "name": "America/Indiana/Petersburg"},
        {"id": "America/Indiana/Tell_City", "name": "America/Indiana/Tell_City"},
        {"id": "America/Indiana/Vevay", "name": "America/Indiana/Vevay"},
        {"id": "America/Indiana/Vincennes", "name": "America/Indiana/Vincennes"},
        {"id": "America/Indiana/Winamac", "name": "America/Indiana/Winamac"},
        {"id": "America/Inuvik", "name": "America/Inuvik"},
        {"id": "America/Iqaluit", "name": "America/Iqaluit"},
        {"id": "America/Jamaica", "name": "America/Jamaica"},
        {"id": "America/Juneau", "name": "America/Juneau"},
        {"id": "America/Kentucky/Louisville", "name": "America/Kentucky/Louisville"},
        {"id": "America/Kentucky/Monticello", "name": "America/Kentucky/Monticello"},
        {"id": "America/Kralendijk", "name": "America/Kralendijk"},
        {"id": "America/La_Paz", "name": "America/La_Paz"},
        {"id": "America/Lima", "name": "America/Lima"},
        {"id": "America/Los_Angeles", "name": "America/Los_Angeles"},
        {"id": "America/Lower_Princes", "name": "America/Lower_Princes"},
        {"id": "America/Maceio", "name": "America/Maceio"},
        {"id": "America/Managua", "name": "America/Managua"},
        {"id": "America/Manaus", "name": "America/Manaus"},
        {"id": "America/Marigot", "name": "America/Marigot"},
        {"id": "America/Martinique", "name": "America/Martinique"},
        {"id": "America/Matamoros", "name": "America/Matamoros"},
        {"id": "America/Mazatlan", "name": "America/Mazatlan"},
        {"id": "America/Menominee", "name": "America/Menominee"},
        {"id": "America/Merida", "name": "America/Merida"},
        {"id": "America/Metlakatla", "name": "America/Metlakatla"},
        {"id": "America/Mexico_City", "name": "America/Mexico_City"},
        {"id": "America/Miquelon", "name": "America/Miquelon"},
        {"id": "America/Moncton", "name": "America/Moncton"},
        {"id": "America/Monterrey", "name": "America/Monterrey"},
        {"id": "America/Montevideo", "name": "America/Montevideo"},
        {"id": "America/Montserrat", "name": "America/Montserrat"},
        {"id": "America/Nassau", "name": "America/Nassau"},
        {"id": "America/New_York", "name": "America/New_York"},
        {"id": "America/Nome", "name": "America/Nome"},
        {"id": "America/Noronha", "name": "America/Noronha"},
        {"id": "America/North_Dakota/Beulah", "name": "America/North_Dakota/Beulah"},
        {"id": "America/North_Dakota/Center", "name": "America/North_Dakota/Center"},
        {"id": "America/North_Dakota/New_Salem", "name": "America/North_Dakota/New_Salem"},
        {"id": "America/Nuuk", "name": "America/Nuuk"},
        {"id": "America/Ojinaga", "name": "America/Ojinaga"},
        {"id": "America/Panama", "name": "America/Panama"},
        {"id": "America/Paramaribo", "name": "America/Paramaribo"},
        {"id": "America/Phoenix", "name": "America/Phoenix"},
        {"id": "America/Port-au-Prince", "name": "America/Port-au-Prince"},
        {"id": "America/Port_of_Spain", "name": "America/Port_of_Spain"},
        {"id": "America/Porto_Velho", "name": "America/Porto_Velho"},
        {"id": "America/Puerto_Rico", "name": "America/Puerto_Rico"},
        {"id": "America/Punta_Arenas", "name": "America/Punta_Arenas"},
        {"id": "America/Rankin_Inlet", "name": "America/Rankin_Inlet"},
        {"id": "America/Recife", "name": "America/Recife"},
        {"id": "America/Regina", "name": "America/Regina"},
        {"id": "America/Resolute", "name": "America/Resolute"},
        {"id": "America/Rio_Branco", "name": "America/Rio_Branco"},
        {"id": "America/Santarem", "name": "America/Santarem"},
        {"id": "America/Santiago", "name": "America/Santiago"},
        {"id": "America/Santo_Domingo", "name": "America/Santo_Domingo"},
        {"id": "America/Sao_Paulo", "name": "America/Sao_Paulo"},
        {"id": "America/Scoresbysund", "name": "America/Scoresbysund"},
        {"id": "America/Sitka", "name": "America/Sitka"},
        {"id": "America/St_Barthelemy", "name": "America/St_Barthelemy"},
        {"id": "America/St_Johns", "name": "America/St_Johns"},
        {"id": "America/St_Kitts", "name": "America/St_Kitts"},
        {"id": "America/St_Lucia", "name": "America/St_Lucia"},
        {"id": "America/St_Thomas", "name": "America/St_Thomas"},
        {"id": "America/St_Vincent", "name": "America/St_Vincent"},
        {"id": "America/Swift_Current", "name": "America/Swift_Current"},
        {"id": "America/Tegucigalpa", "name": "America/Tegucigalpa"},
        {"id": "America/Thule", "name": "America/Thule"},
        {"id": "America/Tijuana", "name": "America/Tijuana"},
        {"id": "America/Toronto", "name": "America/Toronto"},
        {"id": "America/Tortola", "name": "America/Tortola"},
        {"id": "America/Vancouver", "name": "America/Vancouver"},
        {"id": "America/Whitehorse", "name": "America/Whitehorse"},
        {"id": "America/Winnipeg", "name": "America/Winnipeg"},
        {"id": "America/Yakutat", "name": "America/Yakutat"},
        {"id": "Antarctica/Casey", "name": "Antarctica/Casey"},
        {"id": "Antarctica/Davis", "name": "Antarctica/Davis"},
        {"id": "Antarctica/DumontDUrville", "name": "Antarctica/DumontDUrville"},
        {"id": "Antarctica/Macquarie", "name": "Antarctica/Macquarie"},
        {"id": "Antarctica/Mawson", "name": "Antarctica/Mawson"},
        {"id": "Antarctica/McMurdo", "name": "Antarctica/McMurdo"},
        {"id": "Antarctica/Palmer", "name": "Antarctica/Palmer"},
        {"id": "Antarctica/Rothera", "name": "Antarctica/Rothera"},
        {"id": "Antarctica/Syowa", "name": "Antarctica/Syowa"},
        {"id": "Antarctica/Troll", "name": "Antarctica/Troll"},
        {"id": "Antarctica/Vostok", "name": "Antarctica/Vostok"},
        {"id": "Arctic/Longyearbyen", "name": "Arctic/Longyearbyen"},
        {"id": "Asia/Aden", "name": "Asia/Aden"},
        {"id": "Asia/Almaty", "name": "Asia/Almaty"},
        {"id": "Asia/Amman", "name": "Asia/Amman"},
        {"id": "Asia/Anadyr", "name": "Asia/Anadyr"},
        {"id": "Asia/Aqtau", "name": "Asia/Aqtau"},
        {"id": "Asia/Aqtobe", "name": "Asia/Aqtobe"},
        {"id": "Asia/Ashgabat", "name": "Asia/Ashgabat"},
        {"id": "Asia/Atyrau", "name": "Asia/Atyrau"},
        {"id": "Asia/Baghdad", "name": "Asia/Baghdad"},
        {"id": "Asia/Bahrain", "name": "Asia/Bahrain"},
        {"id": "Asia/Baku", "name": "Asia/Baku"},
        {"id": "Asia/Bangkok", "name": "Asia/Bangkok"},
        {"id": "Asia/Barnaul", "name": "Asia/Barnaul"},
        {"id": "Asia/Beirut", "name": "Asia/Beirut"},
        {"id": "Asia/Bishkek", "name": "Asia/Bishkek"},
        {"id": "Asia/Brunei", "name": "Asia/Brunei"},
        {"id": "Asia/Chita", "name": "Asia/Chita"},
        {"id": "Asia/Colombo", "name": "Asia/Colombo"},
        {"id": "Asia/Damascus", "name": "Asia/Damascus"},
        {"id": "Asia/Dhaka", "name": "Asia/Dhaka"},
        {"id": "Asia/Dili", "name": "Asia/Dili"},
        {"id": "Asia/Dubai", "name": "Asia/Dubai"},
        {"id": "Asia/Dushanbe", "name": "Asia/Dushanbe"},
        {"id": "Asia/Famagusta", "name": "Asia/Famagusta"},
        {"id": "Asia/Gaza", "name": "Asia/Gaza"},
        {"id": "Asia/Hebron", "name": "Asia/Hebron"},
        {"id": "Asia/Ho_Chi_Minh", "name": "Asia/Ho_Chi_Minh"},
        {"id": "Asia/Hong_Kong", "name": "Asia/Hong_Kong"},
        {"id": "Asia/Hovd", "name": "Asia/Hovd"},
        {"id": "Asia/Irkutsk", "name": "Asia/Irkutsk"},
        {"id": "Asia/Jakarta", "name": "Asia/Jakarta"},
        {"id": "Asia/Jayapura", "name": "Asia/Jayapura"},
        {"id": "Asia/Jerusalem", "name": "Asia/Jerusalem"},
        {"id": "Asia/Kabul", "name": "Asia/Kabul"},
        {"id": "Asia/Kamchatka", "name": "Asia/Kamchatka"},
        {"id": "Asia/Karachi", "name": "Asia/Karachi"},
        {"id": "Asia/Kathmandu", "name": "Asia/Kathmandu"},
        {"id": "Asia/Khandyga", "name": "Asia/Khandyga"},
        {"id": "Asia/Kolkata", "name": "Asia/Kolkata"},
        {"id": "Asia/Krasnoyarsk", "name": "Asia/Krasnoyarsk"},
        {"id": "Asia/Kuala_Lumpur", "name": "Asia/Kuala_Lumpur"},
        {"id": "Asia/Kuching", "name": "Asia/Kuching"},
        {"id": "Asia/Kuwait", "name": "Asia/Kuwait"},
        {"id": "Asia/Macau", "name": "Asia/Macau"},
        {"id": "Asia/Magadan", "name": "Asia/Magadan"},
        {"id": "Asia/Makassar", "name": "Asia/Makassar"},
        {"id": "Asia/Manila", "name": "Asia/Manila"},
        {"id": "Asia/Muscat", "name": "Asia/Muscat"},
        {"id": "Asia/Nicosia", "name": "Asia/Nicosia"},
        {"id": "Asia/Novokuznetsk", "name": "Asia/Novokuznetsk"},
        {"id": "Asia/Novosibirsk", "name": "Asia/Novosibirsk"},
        {"id": "Asia/Omsk", "name": "Asia/Omsk"},
        {"id": "Asia/Oral", "name": "Asia/Oral"},
        {"id": "Asia/Phnom_Penh", "name": "Asia/Phnom_Penh"},
        {"id": "Asia/Pontianak", "name": "Asia/Pontianak"},
        {"id": "Asia/Pyongyang", "name": "Asia/Pyongyang"},
        {"id": "Asia/Qatar", "name": "Asia/Qatar"},
        {"id": "Asia/Qostanay", "name": "Asia/Qostanay"},
        {"id": "Asia/Qyzylorda", "name": "Asia/Qyzylorda"},
        {"id": "Asia/Riyadh", "name": "Asia/Riyadh"},
        {"id": "Asia/Sakhalin", "name": "Asia/Sakhalin"},
        {"id": "Asia/Samarkand", "name": "Asia/Samarkand"},
        {"id": "Asia/Seoul", "name": "Asia/Seoul"},
        {"id": "Asia/Shanghai", "name": "Asia/Shanghai"},
        {"id": "Asia/Singapore", "name": "Asia/Singapore"},
        {"id": "Asia/Srednekolymsk", "name": "Asia/Srednekolymsk"},
        {"id": "Asia/Taipei", "name": "Asia/Taipei"},
        {"id": "Asia/Tashkent", "name": "Asia/Tashkent"},
        {"id": "Asia/Tbilisi", "name": "Asia/Tbilisi"},
        {"id": "Asia/Tehran", "name": "Asia/Tehran"},
        {"id": "Asia/Thimphu", "name": "Asia/Thimphu"},
        {"id": "Asia/Tokyo", "name": "Asia/Tokyo"},
        {"id": "Asia/Tomsk", "name": "Asia/Tomsk"},
        {"id": "Asia/Ulaanbaatar", "name": "Asia/Ulaanbaatar"},
        {"id": "Asia/Urumqi", "name": "Asia/Urumqi"},
        {"id": "Asia/Ust-Nera", "name": "Asia/Ust-Nera"},
        {"id": "Asia/Vientiane", "name": "Asia/Vientiane"},
        {"id": "Asia/Vladivostok", "name": "Asia/Vladivostok"},
        {"id": "Asia/Yakutsk", "name": "Asia/Yakutsk"},
        {"id": "Asia/Yangon", "name": "Asia/Yangon"},
        {"id": "Asia/Yekaterinburg", "name": "Asia/Yekaterinburg"},
        {"id": "Asia/Yerevan", "name": "Asia/Yerevan"},
        {"id": "Atlantic/Azores", "name": "Atlantic/Azores"},
        {"id": "Atlantic/Bermuda", "name": "Atlantic/Bermuda"},
        {"id": "Atlantic/Canary", "name": "Atlantic/Canary"},
        {"id": "Atlantic/Cape_Verde", "name": "Atlantic/Cape_Verde"},
        {"id": "Atlantic/Faroe", "name": "Atlantic/Faroe"},
        {"id": "Atlantic/Madeira", "name": "Atlantic/Madeira"},
        {"id": "Atlantic/Reykjavik", "name": "Atlantic/Reykjavik"},
        {"id": "Atlantic/South_Georgia", "name": "Atlantic/South_Georgia"},
        {"id": "Atlantic/St_Helena", "name": "Atlantic/St_Helena"},
        {"id": "Atlantic/Stanley", "name": "Atlantic/Stanley"},
        {"id": "Australia/Adelaide", "name": "Australia/Adelaide"},
        {"id": "Australia/Brisbane", "name": "Australia/Brisbane"},
        {"id": "Australia/Broken_Hill", "name": "Australia/Broken_Hill"},
        {"id": "Australia/Darwin", "name": "Australia/Darwin"},
        {"id": "Australia/Eucla", "name": "Australia/Eucla"},
        {"id": "Australia/Hobart", "name": "Australia/Hobart"},
        {"id": "Australia/Lindeman", "name": "Australia/Lindeman"},
        {"id": "Australia/Lord_Howe", "name": "Australia/Lord_Howe"},
        {"id": "Australia/Melbourne", "name": "Australia/Melbourne"},
        {"id": "Australia/Perth", "name": "Australia/Perth"},
        {"id": "Australia/Sydney", "name": "Australia/Sydney"},
        {"id": "Europe/Amsterdam", "name": "Europe/Amsterdam"},
        {"id": "Europe/Andorra", "name": "Europe/Andorra"},
        {"id": "Europe/Astrakhan", "name": "Europe/Astrakhan"},
        {"id": "Europe/Athens", "name": "Europe/Athens"},
        {"id": "Europe/Belgrade", "name": "Europe/Belgrade"},
        {"id": "Europe/Berlin", "name": "Europe/Berlin"},
        {"id": "Europe/Bratislava", "name": "Europe/Bratislava"},
        {"id": "Europe/Brussels", "name": "Europe/Brussels"},
        {"id": "Europe/Bucharest", "name": "Europe/Bucharest"},
        {"id": "Europe/Budapest", "name": "Europe/Budapest"},
        {"id": "Europe/Busingen", "name": "Europe/Busingen"},
        {"id": "Europe/Chisinau", "name": "Europe/Chisinau"},
        {"id": "Europe/Copenhagen", "name": "Europe/Copenhagen"},
        {"id": "Europe/Dublin", "name": "Europe/Dublin"},
        {"id": "Europe/Gibraltar", "name": "Europe/Gibraltar"},
        {"id": "Europe/Guernsey", "name": "Europe/Guernsey"},
        {"id": "Europe/Helsinki", "name": "Europe/Helsinki"},
        {"id": "Europe/Isle_of_Man", "name": "Europe/Isle_of_Man"},
        {"id": "Europe/Istanbul", "name": "Europe/Istanbul"},
        {"id": "Europe/Jersey", "name": "Europe/Jersey"},
        {"id": "Europe/Kaliningrad", "name": "Europe/Kaliningrad"},
        {"id": "Europe/Kirov", "name": "Europe/Kirov"},
        {"id": "Europe/Kyiv", "name": "Europe/Kyiv"},
        {"id": "Europe/Lisbon", "name": "Europe/Lisbon"},
        {"id": "Europe/Ljubljana", "name": "Europe/Ljubljana"},
        {"id": "Europe/London", "name": "Europe/London"},
        {"id": "Europe/Luxembourg", "name": "Europe/Luxembourg"},
        {"id": "Europe/Madrid", "name": "Europe/Madrid"},
        {"id": "Europe/Malta", "name": "Europe/Malta"},
        {"id": "Europe/Mariehamn", "name": "Europe/Mariehamn"},
        {"id": "Europe/Minsk", "name": "Europe/Minsk"},
        {"id": "Europe/Monaco", "name": "Europe/Monaco"},
        {"id": "Europe/Moscow", "name": "Europe/Moscow"},
        {"id": "Europe/Oslo", "name": "Europe/Oslo"},
        {"id": "Europe/Paris", "name": "Europe/Paris"},
        {"id": "Europe/Podgorica", "name": "Europe/Podgorica"},
        {"id": "Europe/Prague", "name": "Europe/Prague"},
        {"id": "Europe/Riga", "name": "Europe/Riga"},
        {"id": "Europe/Rome", "name": "Europe/Rome"},
        {"id": "Europe/Samara", "name": "Europe/Samara"},
        {"id": "Europe/San_Marino", "name": "Europe/San_Marino"},
        {"id": "Europe/Sarajevo", "name": "Europe/Sarajevo"},
        {"id": "Europe/Saratov", "name": "Europe/Saratov"},
        {"id": "Europe/Simferopol", "name": "Europe/Simferopol"},
        {"id": "Europe/Skopje", "name": "Europe/Skopje"},
        {"id": "Europe/Sofia", "name": "Europe/Sofia"},
        {"id": "Europe/Stockholm", "name": "Europe/Stockholm"},
        {"id": "Europe/Tallinn", "name": "Europe/Tallinn"},
        {"id": "Europe/Tirane", "name": "Europe/Tirane"},
        {"id": "Europe/Ulyanovsk", "name": "Europe/Ulyanovsk"},
        {"id": "Europe/Vaduz", "name": "Europe/Vaduz"},
        {"id": "Europe/Vatican", "name": "Europe/Vatican"},
        {"id": "Europe/Vienna", "name": "Europe/Vienna"},
        {"id": "Europe/Vilnius", "name": "Europe/Vilnius"},
        {"id": "Europe/Volgograd", "name": "Europe/Volgograd"},
        {"id": "Europe/Warsaw", "name": "Europe/Warsaw"},
        {"id": "Europe/Zagreb", "name": "Europe/Zagreb"},
        {"id": "Europe/Zurich", "name": "Europe/Zurich"},
        {"id": "Indian/Antananarivo", "name": "Indian/Antananarivo"},
        {"id": "Indian/Chagos", "name": "Indian/Chagos"},
        {"id": "Indian/Christmas", "name": "Indian/Christmas"},
        {"id": "Indian/Cocos", "name": "Indian/Cocos"},
        {"id": "Indian/Comoro", "name": "Indian/Comoro"},
        {"id": "Indian/Kerguelen", "name": "Indian/Kerguelen"},
        {"id": "Indian/Mahe", "name": "Indian/Mahe"},
        {"id": "Indian/Maldives", "name": "Indian/Maldives"},
        {"id": "Indian/Mauritius", "name": "Indian/Mauritius"},
        {"id": "Indian/Mayotte", "name": "Indian/Mayotte"},
        {"id": "Indian/Reunion", "name": "Indian/Reunion"},
        {"id": "Pacific/Apia", "name": "Pacific/Apia"},
        {"id": "Pacific/Auckland", "name": "Pacific/Auckland"},
        {"id": "Pacific/Bougainville", "name": "Pacific/Bougainville"},
        {"id": "Pacific/Chatham", "name": "Pacific/Chatham"},
        {"id": "Pacific/Chuuk", "name": "Pacific/Chuuk"},
        {"id": "Pacific/Easter", "name": "Pacific/Easter"},
        {"id": "Pacific/Efate", "name": "Pacific/Efate"},
        {"id": "Pacific/Fakaofo", "name": "Pacific/Fakaofo"},
        {"id": "Pacific/Fiji", "name": "Pacific/Fiji"},
        {"id": "Pacific/Funafuti", "name": "Pacific/Funafuti"},
        {"id": "Pacific/Galapagos", "name": "Pacific/Galapagos"},
        {"id": "Pacific/Gambier", "name": "Pacific/Gambier"},
        {"id": "Pacific/Guadalcanal", "name": "Pacific/Guadalcanal"},
        {"id": "Pacific/Guam", "name": "Pacific/Guam"},
        {"id": "Pacific/Honolulu", "name": "Pacific/Honolulu"},
        {"id": "Pacific/Kanton", "name": "Pacific/Kanton"},
        {"id": "Pacific/Kiritimati", "name": "Pacific/Kiritimati"},
        {"id": "Pacific/Kosrae", "name": "Pacific/Kosrae"},
        {"id": "Pacific/Kwajalein", "name": "Pacific/Kwajalein"},
        {"id": "Pacific/Majuro", "name": "Pacific/Majuro"},
        {"id": "Pacific/Marquesas", "name": "Pacific/Marquesas"},
        {"id": "Pacific/Midway", "name": "Pacific/Midway"},
        {"id": "Pacific/Nauru", "name": "Pacific/Nauru"},
        {"id": "Pacific/Niue", "name": "Pacific/Niue"},
        {"id": "Pacific/Norfolk", "name": "Pacific/Norfolk"},
        {"id": "Pacific/Noumea", "name": "Pacific/Noumea"},
        {"id": "Pacific/Pago_Pago", "name": "Pacific/Pago_Pago"},
        {"id": "Pacific/Palau", "name": "Pacific/Palau"},
        {"id": "Pacific/Pitcairn", "name": "Pacific/Pitcairn"},
        {"id": "Pacific/Pohnpei", "name": "Pacific/Pohnpei"},
        {"id": "Pacific/Port_Moresby", "name": "Pacific/Port_Moresby"},
        {"id": "Pacific/Rarotonga", "name": "Pacific/Rarotonga"},
        {"id": "Pacific/Saipan", "name": "Pacific/Saipan"},
        {"id": "Pacific/Tahiti", "name": "Pacific/Tahiti"},
        {"id": "Pacific/Tarawa", "name": "Pacific/Tarawa"},
        {"id": "Pacific/Tongatapu", "name": "Pacific/Tongatapu"},
        {"id": "Pacific/Wake", "name": "Pacific/Wake"},
        {"id": "Pacific/Wallis", "name": "Pacific/Wallis"},
    ];
    protected getTemplateHtml(): string{

        return `
            <div class="promo-header ">
                <h2 class="signup-title" data-bind="style: {display: signup}">Account Creation</h3>
            </div>

            <div class="promo-wrapper">
                <div class="promo-body">

                   <div class="w-form w-form-large" id="signup" data-bind="style: {display: signup}" xmlns="http://www.w3.org/1999/html">
                        <div class="form-header short">

                        </div>

                        <div class="w-form-body">
                            <div class="form-body">
                                <strong class="form-sub-title icon i-user-solid">Account Setup</strong>

                                <div class="form-group block-filters">
                                    <label for="plan" class="form-label">Plan</label>
                                    ` + this.plan.getHtmlBuild() + `
                                </div>

                                <hr class="form-hr">

                                <div class="wrap-form-group">
                                    <div class="form-group">
                                        <label for="firstName" class="form-label">First Name</label>
                                        <input id="firstName" data-bind="value: firstName" type="text" class="input-text">
                                    </div>
                                    <div class="form-group">
                                        <label for="lastName" class="form-label">Last Name</label>
                                        <input id="lastName" data-bind="value: lastName" type="text" class="input-text">
                                    </div>
                                </div>

                                <div class="form-group short">
                                    <label for="accountName" class="form-label">Account Name</label>
                                    <p class="form-text small">The name of your account for organizing properties and users.</p>
                                    <input id="accountName" data-bind="value: accountName" type="text" class="input-text">
                                </div>

                                <div class="form-group short">
                                    <label for="loginName" class="form-label">User Name</label>
                                    <!-- <p class="form-text">Nunc pretium malesuada velit, vel pharetra massa volutpat eget.</p> -->
                                    <input id="loginName" data-bind="value: loginName" type="text" class="input-text">
                                </div>

                                <hr class="form-hr">

                                <div class="form-group short">
                                    <label for="email" class="form-label">Email</label>
                                    <p class="form-text small">No spam, guaranteed</p>
                                    <input id="email" data-bind="value: email" type="email" class="input-text">
                                </div>

                                <div class="wrap-form-group">

                                    <div class="form-group">
                                        <label for="password" class="form-label">Password</label>
                                        <input id="password" data-bind="value: password" type="password" class="input-text">
                                    </div>

                                    <div class="form-group">
                                        <label for="password-confirmation" class="form-label">Confirm Password</label>
                                        <input id="password-confirmation" data-bind="value: passwordConfirmation" type="password" class="input-text">
                                    </div>

                                </div>
                                <div class="form-group" style="margin-top: -1rem;">
                                    <p class="form-text small">Min 8 characters with one uppercase, one lowercase, one number, and one special character.</p>
                                </div>

                            </div>
                            <div class="form-body">

                                <strong class="form-sub-title icon i-sources border">Property Setup</strong>

                                <div class="form-group short">
                                    <label for="brandName" class="form-label">Property Name
                                        <!--
                                        <div class="w-tooltips-adv short auto-height short pos-top">
                                            ${this.propertyName.getHtmlBuild()}
                                        </div>
                                        -->
                                    </label>
                                    <p class="form-text small">This is how your site will appear in reports.</p>
                                    <input id="brandName" data-bind="value: brandName" type="text" class="input-text">
                                </div>
                                <div class="form-group">
                                    <label for="brandShortName" class="form-label short">Property Short Name
                                        <!--
                                        <div class="w-tooltips-adv auto-height short pos-top">
                                            ${this.propertyShortName.getHtmlBuild()}
                                        </div>
                                        -->
                                    </label>
                                    <p class="form-text small">A shorter label for this site in reports (2-5 letters).</p>
                                    <input id="brandShortName" data-bind="value: brandShortName" type="text" class="input-text very-short">
                                </div>
                                <div class="form-group">
                                    <label for="brandDomain" class="form-label">Property Domain

                                        <!--
                                        <div class="w-tooltips-adv auto-height short pos-top">
                                            ${this.propertyDomain.getHtmlBuild()}
                                        </div>
                                        -->
                                    </label>
                                    <p class="form-text small">Just the domain or subdomain—no 'www' or 'https'.</p>
                                    <input id="brandDomain" data-bind="value: brandDomain" type="url" class="input-text">
                                </div>

                                <div class="form-group block-filters">
                                    <label for="timezone" class="form-label">Reporting time zone</label>
                                    ` + this.timezone.getHtmlBuild() + `
                                </div>

                            </div>

                        </div>
                        <div class="form-footer">

                            <!-- ko if: planId() == 1 -->
                                <button class="btn dark full" type="button" data-bind="event: { click: onClickSignUpAction}">Create Account</button>
                            <!-- /ko -->

                            <!-- ko if: planId() >= 2 && planId() <= 4 -->
                                <button class="btn dark full" type="button" data-bind="event: { click: onClickCheckoutAction}">Checkout</button>
                            <!-- /ko -->

                        </div>
                        <div class="w-form-body">
                            <div class="form-body sub-footer full-width">
                                <div class="form-group">
                                    <p class="form-text">Have any questions or need help?<br>Our support team is always happy to assist!<br />
                                    <a href="mailto:support@sentinelpro.com">support@sentinelpro.com</a></p>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="w-form w-form-large medium" id="checkout" data-bind="style: {display: checkout}">
                        <div class="form-header w-justify">
                            <div class="w-left" style="flex:none;">
                                <button class="btn no-bg icon i-back" type="button" data-bind="event: { click: onBackToSignUpAction}"><span class="hide-text">Back</span></button>
                            </div>
                            <div class="w-center">
                                <h3 class="form-title logo">Checkout</h3>
                            </div>
                        </div>
                        <div class="w-form-body">
                            <div class="form-body extra-padding">
                                <div class="w-pricing-container form-group" >
                                    <!-- ko if: planId() == 2 -->
                                    <div class="pricing-card">
                                        <h3>Essential</h3>
                                        <div class="price" data-bind="html: calculatePrice()"></div>
                                        <hr>
                                        <ul>
                                            <li><strong><span>up to 10M hits per month</span></strong></li>
                                            <li><strong><span>Long Term Data</span></strong></li>
                                            <li><strong><span>API</span></strong></li>
                                            <li><span>Unlimited features</span></li>
                                            <li><span>Unlimited properties</span></li>
                                            <li class="no-before" style="display: none;"><span>label</span><hr></li>
                                            <li><span>Exports</span></li>
                                            <li><span>Custom events</span></li>
                                        </ul>
                                    </div>
                                    <!-- /ko -->

                                    <!-- ko if: planId() == 3 -->
                                    <div class="pricing-card">
                                        <h3>Advanced</h3>
                                        <div class="price" data-bind="html: calculatePrice()"></div>
                                        <hr>
                                        <ul>
                                            <li><strong><span>up to 50M hits per month</span></strong></li>
                                            <li><strong><span>Long Term Data</span></strong></li>
                                            <li><strong><span>API</span></strong></li>
                                            <li><span>Unlimited features</span></li>
                                            <li><span>Unlimited properties</span></li>
                                            <li><span>Exports</span></li>
                                            <li><span>Custom events</span></li>

                                        </ul>
                                    </div>
                                    <!-- /ko -->

                                    <!-- ko if: planId() == 4 -->
                                    <div class="pricing-card">
                                        <h3>Pro</h3>
                                        <div class="price" data-bind="html: calculatePrice()"></div>
                                        <hr>
                                        <ul>
                                            <li><strong><span>up to 100M hits per month</strong></li>
                                            <li><strong><span>Long Term Data</span></strong></li>
                                            <li><strong><span>API</span></strong></li>
                                            <li><span>Unlimited features</span></li>
                                            <li><span>Unlimited properties</span></li>
                                            <li><span>Exports</span></li>
                                            <li><span>Custom events</span></li>
                                        </ul>
                                    </div>
                                    <!-- /ko -->
                                </div>
                            </div>
                            <div class="form-body extra-padding">
                                <hr class="form-hr only-mobile margin">
                                <div class="form-group">
                                    <label for="billingEmail" class="form-label">Email</label>
                                    <input id="billingEmail" data-bind="value: billingEmail, attr: { 'readonly': billingEmailSameAsAccount}" type="email" class="input-text" style="margin-bottom: .3rem;">
                                    <input type="checkbox" id="billingEmailSameAsAccountCheck" name="billingEmailSameAsAccountCheck" data-bind="checked: billingEmailSameAsAccount, event: {change: onClickBillingEmailSameAsAccount},">
                                    <label for="billingEmailSameAsAccountCheck" class="form-label form-label icon i-check">Same as Account</label>
                                </div>
                                <div class="form-group">


                                </div>
                                <div class="form-group">
                                    <label class="form-label">Card Details</label>
                                    <div id="card-element" class="feild-border"></div>
                                    <p class="form-text error" data-bind="visible: message(),text: message"></p>
                                </div>

                                <div class="form-group">


                                </div>
                                <div class="form-group">
                                    <label for="promoCode" class="form-label">Promo Code</label>
                                    <input id="promoCode" data-bind="visible: promoCodeId() == '', value: promoCode" type="input" class="input-text" style="margin-bottom: .3rem;">
                                    <p class="form-text" data-bind="visible: promoCodeId() !== '',text: promoCodeDescription"></p>
                                    <button class="btn dark full" type="button" data-bind="attr: { style: promoCodeId() == '' ? 'display: inline-block' : 'display: none !important;' }, event: { click: onClickApplyPromo}">Apply</button>
                                    <button class="btn dark full" type="button" data-bind="attr: { style: promoCodeId() !== '' ? 'display: inline-block' : 'display: none !important;' }, event: { click: onClickRemovePromo}">Remove</button>
                                    <p class="form-text error" data-bind="visible: promoCodeMessage(),text: promoCodeMessage"></p>
                                </div>

                                <hr class="form-hr margin">

                                <div class="form-group">
                                    <p>By subscribing to this service, you agree to recurring payments as per your selected plan. You can cancel your subscription at any time through your account settings, and your access will remain active until the end of the billing period.</p>
                                </div>

                            </div>
                        </div>

                        <div class="form-footer" style="padding: 1rem;">
                            <button class="btn dark full" type="button" data-bind="event: { click: onClickPaidSignUpAction}">Create Account</button>
                        </div>

                        <div class="w-form-body">
                            <div class="form-body sub-footer full-width">
                                <div class="form-group">
                                    <p class="form-text">Have any questions or need help?<br>Our support team is always happy to assist!<br />
                                    <a href="mailto:support@sentinelpro.com">support@sentinelpro.com</a></p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="w-form" id="confirm-email" data-bind="style: {display: emailSent}">
                        <div class="form-header">
                            <h3 class="form-title logo">Confirmation Email Sent</h3>
                        </div>
                        <div class="form-body extra-padding">
                            <div class="form-group" >
                                <p class="form-text">A confirmation email has been sent to your registered email address.</p>
                                <p class="form-text">Please click the link in the email to verify your account.</p>
                                <p class="form-text"><a href="mailto:support@sentinelpro.com">support@sentinelpro.com</a></p>
                            </div>
                        </div>
                        <div class="form-body sub-footer">
                            <div class="form-group">
                                <p class="form-text">Have any questions or need help?<br>Our support team is always happy to assist!<br />
                                <a href="mailto:support@sentinelpro.com">support@sentinelpro.com</a></p>
                            </div>
                        </div>
                        <div class="form-footer" style="padding: 1rem;">

                        </div>
                    </div>


                    <div class="w-form" id="processing-token" data-bind="style: {display: processingToken}">
                        <div class="form-header">
                            <h3 class="form-title logo">Validating Account</h3>
                        </div>
                        <div class="form-body extra-padding">
                            <div class="form-group load">
                                <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'><circle fill='#67308F' stroke='#67308F' stroke-width='15' r='15' cx='40' cy='65'><animate attributeName='cy' calcMode='spline' dur='2' values='65;135;65;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='-.4'></animate></circle><circle fill='#67308F' stroke='#67308F' stroke-width='15' r='15' cx='100' cy='65'><animate attributeName='cy' calcMode='spline' dur='2' values='65;135;65;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='-.2'></animate></circle><circle fill='#67308F' stroke='#67308F' stroke-width='15' r='15' cx='160' cy='65'><animate attributeName='cy' calcMode='spline' dur='2' values='65;135;65;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='0'></animate></circle></svg>
                            </div>
                            <div class="form-group">
                                <p class="form-text">Please hold on while we validate your account. This process may take a moment. Avoid refreshing the page..</p>
                            </div>

                        </div>
                        <div class="form-body sub-footer">
                            <div class="form-group">
                                <p class="form-text">Have any questions or need help?<br>Our support team is always happy to assist!<br />
                                <a href="mailto:support@sentinelpro.com">support@sentinelpro.com</a></p>
                            </div>
                        </div>

                        <div class="form-footer" style="padding: 1rem;">

                        </div>
                    </div>


                    <div class="w-form" id="invalid-token" data-bind="style: {display: invalidToken}">
                        <div class="form-header">
                            <h3 class="form-title logo">Invalid token</h3>
                        </div>
                        <div class="form-body extra-padding">
                            <div class="form-group">
                                <p class="form-text">The token provided is invalid.</p>
                                <p class="form-text">Please request a new one and try again.</p>
                            </div>
                        </div>
                        <div class="form-body sub-footer">
                            <div class="form-group">
                                <p class="form-text">Have any questions or need help?<br>Our support team is always happy to assist!<br />
                                <a href="mailto:support@sentinelpro.com">support@sentinelpro.com</a></p>
                            </div>
                        </div>
                        <div class="form-footer" style="padding: 1rem;">

                        </div>
                    </div>

                    <div class="w-form" id="expired-token" data-bind="style: {display: expiredToken}">
                        <div class="form-header">
                            <h3 class="form-title logo">Token Expired</h3>
                        </div>
                        <div class="form-body extra-padding">
                            <div class="form-group">
                                <p class="form-text">Your token has expired.</p>
                                <p class="form-text">Please request a new one to proceed.</p>
                            </div>
                            <div class="form-group">
                                <button class="btn dark full" type="button" data-bind="event: { click: onClickRenewTokenAction}">Renew Token</button>
                            </div>
                        </div>
                        <div class="form-body sub-footer">
                            <div class="form-group">
                                <p class="form-text">Have any questions or need help?<br>Our support team is always happy to assist!<br />
                                <a href="mailto:support@sentinelpro.com">support@sentinelpro.com</a></p>
                            </div>
                        </div>
                        <div class="form-footer" style="padding: 1rem;">
                        </div>
                    </div>

                    <div class="w-form" id="welcome" data-bind="style: {display: signupComplete}">
                        <div class="form-header">
                            <h3 class="form-title logo">Welcome to SentinelPro</h3>
                        </div>
                        <div class="form-body extra-padding">
                            <div class="form-group">
                                <p class="form-text"> Dear <span data-bind="text: fullName"></span>,</p>
                                <p class="form-text"><strong>Thanks for signing up</strong> — you're almost there!</p><br>

                                <!-- ko if: planId() == 1 -->
                                    <p class="form-text">Your account is now in the queue for activation.</p><br>
                                <!-- /ko -->

                                <!-- ko if: planId() > 1 -->
                                    <p class="form-text">Your payment has been confirmed, and your account is now in the queue for activation.</p><br>
                                <!-- /ko -->

                                <p class="form-text">Once everything is set up, we’ll send you a confirmation email along with your login details.</p><br>

                                <p class="form-text">Here’s what will happen next:</p>
                                <ul class="form-list">
                                    <li class="form-text"><strong>You'll receive an email</strong> with your login information as soon as your account is ready.</li>
                                    <li class="form-text"><strong>After logging in</strong>, you’ll be able to:<br><br>
                                        <ul>
                                            <li class="form-text">Set up your first property by going to <strong>Account Settings → Account Details</strong> to find your tracking code and start collecting data.</li>
                                            <li class="form-text">Invite your team through <strong>Account Settings → Account Users</strong> to add collaborators and stay aligned.</li>
                                            <li class="form-text">Explore your dashboard to monitor real-time metrics, track custom events, and dive deep into tailored reports.</li>
                                        </ul>
                                    </li>
                                </ul>

                                <br>
                                <p class="form-text">Need help in the meantime? Our support team is here for you — just reach out!</p><br>
                                <p class="form-text">We can't wait to help you unlock powerful insights with <strong>SentinelPro</strong>.</p>
                                <br>
                                <p class="form-text">Best,</p>

                                <p class="form-text">
                                    <strong>The SentinelPro Team</strong>
                                </p>

                            </div>

                        </div>

                        <div class="form-footer" style="padding: 1rem;">

                        </div>
                    </div>

                </div>

                <footer class="default-footer">
                    <div>
                        <div class="default-footer-left">
                            <a href="/"><img src="/assets/images/logo-mark-white.svg" alt="Logo"></a>
                            <ul>
                                <li><a onclick="window.location.assign('https://sentinelpro.com')">Home</a></li>
                                <li><a onclick="window.location.assign('https://sentinelpro.com/pages/pricing')">Pricing</a></li>
                                <li><a onclick="window.location.assign('https://sentinelpro.com/pages/contact')">Contact</a></li>
                                <li><a onclick="window.location.assign('https://sentinelpro.com/pages/privacy-policy')">Privacy Policy</a></li>
                                <li><a onclick="window.location.assign('https://sentinelpro.com/pages/terms-and-services')">Terms and Services</a></li>

                            </ul>
                        </div>
                        <div class="default-footer-right">
                            <p>&copy; 2025 ValServ Inc. All rights reserved.</p>
                        </div>
                    </div>
                </footer>
            </div>
            `;
    }

    protected getTemplateName(): string{
        return "signup_template";
    }

    protected initPartial(): void{

        this.propertyName = new infoButton_template('propertyName', this.getTemplateViewModel(), this.caller)
        this.propertyName.setContent(`<p><strong>Property Name :</strong>Use only letters and digits.</p>`);

        this.propertyShortName = new infoButton_template('propertyShortName', this.getTemplateViewModel(), this.caller)
        this.propertyShortName.setContent(`<p><strong>Property Short Name :</strong> 2-5 characters (e.g., "YourSite" → "YS").</p>`);

        this.propertyDomain = new infoButton_template('propertyDomain', this.getTemplateViewModel(), this.caller)
        this.propertyDomain.setContent(`<p><strong>Property Name :</strong>Use only letters and digits.</p>`);

        this.plan = new filterSingle_multiLevel_selector_template('plan', this.getTemplateViewModel(), this.caller);

        this.timezone = new filterSingle_multiLevel_selector_template('timezone', this.getTemplateViewModel(), this.caller);
    }

    protected getMainElementClasses(): Array<string>{
        return ["promo-style", "page-content"];
    }

    public initCardElement() {

        card.mount('#card-element');
    }


    protected buildViewModel(): any{

        let huit_neuf_this = this;
        return  {
            recaptchaToken: ko.observable(""),
            planId: ko.observable(1),
            planPrices: ko.observableArray([
                { id: '2', price: 299 },
                { id: '3', price: 699 },
                { id: '4', price: 999 }
            ]),
            accountName: ko.observable(""),
            firstName: ko.observable(""),
            lastName: ko.observable(""),
            loginName: ko.observable(""),
            fullName: ko.observable(""),
            password: ko.observable(""),
            passwordConfirmation: ko.observable(""),
            email: ko.observable(""),
            brandName: ko.observable(""),
            brandShortName: ko.observable(""),
            brandDomain: ko.observable(""),
            serverCalls: ko.observable(""),
            paymentMethodId: ko.observable(""),
            billingEmail: ko.observable(""),
            billingEmailSameAsAccount: ko.observable(false),
            message: ko.observable(""),
            promoCode: ko.observable(""),
            promoCodeId: ko.observable(""),
            promoCodeType: ko.observable(""),
            promoCodeAmount: ko.observable(""),
            promoCodeDescription: ko.observable(""),
            promoCodeMessage: ko.observable(""),

            signup: ko.observable("none"),
            checkout: ko.observable("none"),
            emailSent: ko.observable("none"),
            processingToken: ko.observable("none"),
            invalidToken: ko.observable("none"),
            expiredToken: ko.observable("none"),
            signupComplete: ko.observable("none"),

            onClickSignUpAction: function(data, event){ huit_neuf_this.onClickSignUpAction(); },
            onClickCheckoutAction: function(data, event){ huit_neuf_this.onClickCheckoutAction(); },
            onClickPaidSignUpAction: function(data, event){ huit_neuf_this.onClickPaidSignUpAction(); },
            onBackToSignUpAction: function(data, event){ huit_neuf_this.onBackToSignUpAction(); },
            onClickRenewTokenAction: function(data, event){ huit_neuf_this.onClickRenewTokenAction(); },
            onClickBillingEmailSameAsAccount: function(data, event){ return huit_neuf_this.onClickBillingEmailSameAsAccount(data, event); },
            onClickApplyPromo: function(data, event){ return huit_neuf_this.onClickApplyPromo(); },
            onClickRemovePromo: function(data, event){ return huit_neuf_this.onClickRemovePromo(); },
            calculatePrice: function(){return ko.computed(function () { return huit_neuf_this.calculatePrice();}, this)},
        };
    }

    public getViewModelForRequest(): Object{

        return {

            recaptchaToken: this.getTemplateViewModel().recaptchaToken(),
            accountName: this.getTemplateViewModel().accountName(),
            firstName: this.getTemplateViewModel().firstName(),
            lastName: this.getTemplateViewModel().lastName(),
            loginName: this.getTemplateViewModel().loginName(),
            password: this.getTemplateViewModel().password(),
            passwordConfirmation: this.getTemplateViewModel().passwordConfirmation(),
            email: this.getTemplateViewModel().email(),
            billingEmail: this.getTemplateViewModel().billingEmail(),
            brandName: this.getTemplateViewModel().brandName(),
            brandShortName: this.getTemplateViewModel().brandShortName(),
            brandDomain: this.getTemplateViewModel().brandDomain(),
            plan: this.plan.getSelectedOption(),
            timezone: this.timezone.getSelectedOptionText(),
            serverCalls: this.getTemplateViewModel().serverCalls(),
            paymentMethodId: this.getTemplateViewModel().paymentMethodId(),
            promoCode: this.getTemplateViewModel().promoCode(),
            promoCodeId: this.getTemplateViewModel().promoCodeId()
        };
    }

    protected onClickSignUpAction(){

        load(vnApp_sentinelbi.RECAPTCHA_SITE_KEY, { autoHideBadge: true })
        .then((recaptcha) => recaptcha.execute('signup'))
        .then((token) => {
            this.getTemplateViewModel().recaptchaToken(token);
            this.caller.signup();
        })
        .catch((error) => {
            console.error('reCAPTCHA failed', error);
        });
    }

    protected onClickBillingEmailSameAsAccount(data, event){

        let val = this.getTemplateViewModel().billingEmailSameAsAccount();

        if (val) {

            this.getTemplateViewModel().billingEmail(this.getTemplateViewModel().email());
        }else {

            this.getTemplateViewModel().billingEmail('');
        }
    }

    protected onClickCheckoutAction(){

        this.caller.validateSignup();
    }

    protected onBackToSignUpAction(){

        this.getTemplateViewModel().checkout("none");
        this.getTemplateViewModel().signup("block");
    }

    protected onClickPaidSignUpAction(){

        if (!this.isValidEmail(this.getTemplateViewModel().billingEmail())) {

            this.getTemplateViewModel().message('Error: Invalid Email');
        }else {

            stripe.createPaymentMethod({
                type: 'card',
                card: card,
            }).then((result) => {

                if (result.error) {
                    // Handle error

                    this.getTemplateViewModel().message('Error: ' + result.error.message);
                } else {

                    this.getTemplateViewModel().paymentMethodId(result.paymentMethod.id);
                    this.caller.signup();
                }
            });
        }
    }

    protected onClickRenewTokenAction(){

        this.caller.renewToken();
    }

    public setTimeZones(){

        this.timezone.setGroups(this.timezones.map(p => {

            return {
                id: p.id,
                name: p.name,
                type: '',
                cssClasses: ''
            }
        }));

        let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        let foundZone = this.timezones.find((i => i.id === userTimeZone));

        if (foundZone){

            this.timezone.setSelectedOption('_' + foundZone.id);
            this.timezone.setSelectedOptionText(foundZone.name);
        }
    }

    public initPlans() {

        this.plan.setGroups(this.plans.map(p => {

            return {
                id: p.id,
                name: p.name,
                type: '',
                cssClasses: ''
            }
        }));

        this.updatePlanId();

    }

    public updatePlanId() {

        this.getTemplateViewModel().planId(this.plan.getSelectedOption());
        //console.log(this.getTemplateViewModel().planId());
    }

    public setPlan(plan) {

        let foundPlan = this.plans.find((i => i.name === plan));

        if (foundPlan){

            this.plan.setSelectedOption(foundPlan.id);
            this.plan.setSelectedOptionText(foundPlan.name);
            this.updatePlanId();
        }

    }

    private isValidEmail(email: string) {

        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    protected onClickApplyPromo(){

        this.getTemplateViewModel().promoCodeMessage('');
        this.caller.applyPromo();
    }

    protected onClickRemovePromo(){

        let data = {
            "id" : "",
            "type" : "",
            "amount" : "",
            "description" : "",
            "message" : "",
        };

        this.getTemplateViewModel().promoCode('');
        this.setPromoCodeData(data);
    }

    public setPromoCodeData($data) {

        this.getTemplateViewModel().promoCodeId($data.id);
        this.getTemplateViewModel().promoCodeType($data.type);
        this.getTemplateViewModel().promoCodeAmount($data.amount);
        this.getTemplateViewModel().promoCodeDescription($data.description);
        this.getTemplateViewModel().promoCodeMessage($data.message);
    }

    public calculatePrice() {

        let map = {};
        this.getTemplateViewModel().planPrices().forEach(plan => {
            map[plan.id] = plan.price;
        });

        let planPrice = map[this.getTemplateViewModel().planId()];

        if (this.getTemplateViewModel().promoCodeId !== '') {

            let promoCodeAmount = this.getTemplateViewModel().promoCodeAmount();

            if (this.getTemplateViewModel().promoCodeType() == 'percent_off') {

                planPrice = planPrice - (planPrice * (promoCodeAmount / 100));
            }

            if (this.getTemplateViewModel().promoCodeType() == 'amount_off') {

                planPrice = planPrice - promoCodeAmount;
            }

            planPrice = (planPrice % 1 === 0) ? planPrice : planPrice.toFixed(2);
        }
        return "$" + planPrice + "<small> USD/mo</small>";
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/signup_template.ts